import React from "react";
import { FormattedMessage } from "react-intl";
import { Radio } from "antd";

const Frequency = ({frequencyType, setFrequencyType}) => {
  return (
    <>
      <div className="labelDialogContent">
        <FormattedMessage id="deadlines.pages.create.typeOfFrequency" />
      </div>
      <Radio.Group
        data-testid="radio-recurrence"
        onChange={e => {
          setFrequencyType(e.target.value);          
        }}
        value={frequencyType}
      >
        <Radio value={"single"}><FormattedMessage id="deadlines.pages.create.single" /></Radio>
        <Radio value={"recurring"}><FormattedMessage id="deadlines.pages.create.recurring" /></Radio>
      </Radio.Group>      
    </>
  );
};

export default Frequency;